export class Language {
  abr: string = '';
  language: string = '';
}
